/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.newsletter', {
            parent: 'board.project-detail',
            url: '/newsletter',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title5'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/newsletter/project-detail-newsletter.html',
                    controller: 'ProjectDetailNewsletterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'board.project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();
